/**
 * Auto-describe a character image so @-tags can lock likeness in the prompt.
 * @param {import('../../../context/GlobalContext').default} hitAxios
 * @param {{ file?: File; imageUrl?: string; label?: string }} opts
 * @returns {Promise<{ identity: string; label_hint?: string } | null>}
 */
export async function describeCharacterImage(hitAxios, opts = {}) {
  const file = opts.file;
  const imageUrl = String(opts.imageUrl || "").trim();
  const label = String(opts.label || "").trim();
  if (!file && !imageUrl) return null;
  if (!hitAxios) return null;

  const body = new FormData();
  if (file instanceof File) body.append("image", file);
  else if (imageUrl && !imageUrl.startsWith("blob:")) body.append("image_url", imageUrl);
  else return null;
  if (label) body.append("label", label);

  try {
    const res = await hitAxios({
      path: "/api/video-studio/describe-image",
      post: true,
      obj: body,
      showLoading: false,
      showSnackbar: false,
      timeout: 60000,
    });
    if (!res?.data?.success || !res?.data?.data?.identity) return null;
    return {
      identity: String(res.data.data.identity).trim(),
      label_hint: res.data.data.label_hint
        ? String(res.data.data.label_hint).trim()
        : undefined,
    };
  } catch {
    return null;
  }
}
